// @ts-nocheck
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {BaseButton, BaseTooltip} from "@/components";
import {findBankData} from "../../../adapters/bankListAdapter";
import warningIcon from "../../../assets/images/modal-icons/advertencia-bell-icon.png";
import editIcon from "../../../assets/images/modal-icons/edit-icon.png";
import eraseIcon from "../../../assets/images/modal-icons/erase-icon.png";
import useDeleteAccPagoMovil from "../../../hooks/wallet/useDeleteAccPagoMovil";
import useGetAccountPagoMovil from "../../../hooks/wallet/useGetAccountPagoMovil";
import {useBalanceStore} from "../../../store/useBalance.store";
import AddPagoMovilForm from "../../Forms/AddPagoMovil";
import BaseModal from "../index";

const itemCls = "p-4 flex flex-col gap-3 max-md:flex-row max-md:items-start max-md:gap-4";
const actionsCls = "flex justify-end gap-2 max-md:shrink-0 max-md:flex-row max-md:gap-2 max-md:order-2";
const contentCls = "flex flex-col gap-3 max-md:flex-1 max-md:order-1";
const infoRowCls = "flex justify-between items-center max-md:flex-col max-md:items-start max-md:gap-1";
const labelCls =
  "text-[var(--text-secondary)] font-[var(--ant-font-family)] font-normal text-base leading-[var(--leading-xl)] max-md:text-sm max-md:leading-5";
const valueCls =
  "text-[var(--text-secondary)] font-[var(--ant-font-family)] font-normal text-base leading-[var(--leading-xl)] max-md:text-base max-md:leading-6 max-md:font-medium";

const PagoMovilListModal = () => {
  const {t} = useTranslation();
  const {data, isLoading, refetch} = useGetAccountPagoMovil();
  const {deleteAcc} = useDeleteAccPagoMovil();

  const [addModalVisible, setAddModalVisible] = useState(false);
  const [addModalKey, setAddModalKey] = useState(0);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [accData, setAccData] = useState({});
  const [deleteData, setDeleteData] = useState({});

  const isMobile = window.innerWidth <= 768;

  const pagoMovilListModalVisible = useBalanceStore(state => state.pagoMovilListModalVisible);
  const handlePagoMovilListModal = useBalanceStore(state => state.handlePagoMovilListModal);

  const handleAddModal = () => {
    setAddModalVisible(prev => {
      const next = !prev;
      if (next) {
        setAddModalKey(k => k + 1); // increment key when opening
      }
      return next;
    });
  };

  const handleEditModal = item => {
    setAccData(item);
    setEditModalVisible(!editModalVisible);
  };

  const handleDeleteModal = item => {
    setDeleteData(item);
    setDeleteConfirmVisible(true);
  };

  const handleConfirmDelete = () => {
    deleteAcc(deleteData.ID);
    setDeleteConfirmVisible(false);
    setDeleteData({});
    refetch();
  };

  const handleCancelDelete = () => {
    setDeleteConfirmVisible(false);
    setDeleteData({});
  };

  // Handler to close modal and refetch list after add
  const handleAddSuccess = () => {
    handleAddModal();
    refetch();
  };

  return (
    <>
      {/* ...removed inline style, now using CSS module... */}
      <BaseModal
        title={t("mobilePaymentTitle")}
        state={pagoMovilListModalVisible}
        closeModal={handlePagoMovilListModal}
        width={600}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--space-4-5)",
            height: "100%",
          }}
        >
          {/* Pago Movil List */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-3-5)",
              flex: 1,
              overflowY: "auto",
              paddingRight: "var(--space-2-5)",
              minHeight: 0,
            }}
          >
            {isLoading ? (
              <div style={{color: "var(--text-secondary)", textAlign: "center"}}>{t("loading")}...</div>
            ) : data && data.length > 0 ? (
              data.map((item, index) => (
                <div key={item.ID}>
                  <div className={itemCls}>
                    {/* Edit/Delete buttons at the top for desktop, on the right for mobile */}
                    <div className={actionsCls}>
                      <BaseTooltip title={t("mobilePaymentEdit")}>
                        <img
                          src={editIcon}
                          alt="Edit"
                          onClick={() => handleEditModal(item)}
                          style={{
                            cursor: "pointer",
                            width: "12px",
                            height: "12px",
                            padding: "var(--space-1)",
                          }}
                        />
                      </BaseTooltip>
                      <BaseTooltip title={t("mobilePaymentDelete")}>
                        <img
                          src={eraseIcon}
                          alt="Delete"
                          onClick={() => handleDeleteModal(item)}
                          style={{
                            cursor: "pointer",
                            width: "12px",
                            height: "12px",
                            padding: "var(--space-1)",
                          }}
                        />
                      </BaseTooltip>
                    </div>

                    {/* Content section with bank and phone info */}
                    <div className={contentCls}>
                      {/* Bank information row */}
                      <div className={infoRowCls}>
                        <span className={labelCls}>{t("mobilePaymentBank")}:</span>
                        <span className={valueCls}>{findBankData(item)?.bank_name}</span>
                      </div>

                      {/* Phone information row */}
                      <div className={infoRowCls}>
                        <span className={labelCls}>{t("mobilePaymentPhone")}:</span>
                        <span className={valueCls}>{item.phone_number}</span>
                      </div>
                    </div>
                  </div>
                  {/* Separator line between items, but not after the last item */}
                  {index < data.length - 1 && (
                    <div
                      style={{
                        borderTop: "1px solid #666",
                        margin: "0 16px",
                      }}
                    />
                  )}
                </div>
              ))
            ) : (
              <div
                style={{
                  color: "var(--color-secondary)",
                  textAlign: "center",
                  padding: "40px 20px",
                }}
              >
                {t("noDataAvailable")}
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "var(--space-4-5)",
              marginTop: "var(--space-5)",
              paddingTop: "var(--space-5)",
              paddingBottom: "var(--space-5)",
              borderTop: "1px solid #666",
              flexShrink: 0,
            }}
          >
            <BaseButton
              variant="secondary"
              onClick={handlePagoMovilListModal}
              className="btn-tertiary-hover"
              style={{
                borderRadius: "var(--radius-md)",
                minWidth: "100px",
              }}
            >
              {t("mobilePaymentBtnBack")}
            </BaseButton>
            <BaseButton
              variant="secondary"
              onClick={handleAddModal}
              className="btn-secondary-hover"
              style={{
                borderRadius: "var(--radius-md)",
                minWidth: "100px",
              }}
            >
              {t("mobilePaymentBtnAdd")}
            </BaseButton>
          </div>
        </div>
      </BaseModal>

      {/* Add Pago Movil Modal */}
      <BaseModal
        title={t("mobilePaymentAdd")}
        state={addModalVisible}
        closeModal={handleAddModal}
      >
        <AddPagoMovilForm
          key={addModalKey}
          onSuccess={handleAddSuccess}
        />
      </BaseModal>

      {/* Edit Pago Movil Modal */}
      <BaseModal
        title={t("mobilePaymentEditTitle")}
        state={editModalVisible}
        closeModal={handleEditModal}
      >
        <AddPagoMovilForm
          isUpdate={true}
          data={accData}
        />
      </BaseModal>

      {/* Delete Confirmation Modal */}
      {deleteConfirmVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            backdropFilter: "blur(5px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
          onClick={handleCancelDelete}
        >
          <div
            style={{
              backgroundColor: "var(--color-gray-6)",
              padding: isMobile ? "10px" : "30px",
              borderRadius: "var(--radius-lg)",
              textAlign: "center",
              width: "var(--size-125)",
              // border: "1px solid #666",
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Warning Icon */}
            <div style={{marginBottom: "var(--space-5)"}}>
              <img
                src={warningIcon}
                alt="Warning"
                style={{
                  width: isMobile ? "38px" : "48px",
                  height: isMobile ? "38px" : "48px",
                }}
              />
            </div>

            {/* Bank Information */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "var(--space-3-5)",
                color: "var(--text-secondary)",
                fontSize: isMobile ? "14px" : "16px",
              }}
            >
              <span style={{color: "#ccc"}}>{t("deleteConfirmationBank")}:</span>
              <span>{findBankData(deleteData)?.bank_name}</span>
            </div>

            {/* Phone Information */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "var(--space-5)",
                color: "var(--text-secondary)",
                fontSize: isMobile ? "14px" : "16px",
              }}
            >
              <span style={{color: "#ccc"}}>{t("deleteConfirmationPhone")}:</span>
              <span>{deleteData.phone_number}</span>
            </div>

            {/* Divider Line */}
            <div
              style={{
                borderTop: "1px solid #666",
                margin: "20px 0",
              }}
            />

            {/* Warning Message */}
            <div
              style={{
                color: "var(--color-secondary)",
                fontSize: "var(--font-h3)",
                marginBottom: "30px",
                lineHeight: "1.4",
              }}
            >
              {t("deleteConfirmationMessage")}
            </div>

            {/* Action Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "var(--space-3-5)",
              }}
            >
              <BaseButton
                variant="secondary"
                onClick={handleConfirmDelete}
                className="btn-tertiary-hover"
                style={{
                  borderRadius: "var(--radius-md)",
                  minWidth: "100px",
                }}
              >
                {t("accept")}
              </BaseButton>
              <BaseButton
                variant="secondary"
                onClick={handleCancelDelete}
                className="btn-cancel-hover"
                style={{
                  borderRadius: "var(--radius-md)",
                  minWidth: "100px",
                }}
              >
                {t("cancel")}
              </BaseButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PagoMovilListModal;
